var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box } from "@mui/material";
const ScrollableTabContainer = (_a) => {
    var { children, sx, mt = 1, mb = 0, p = 0.4 } = _a, rest = __rest(_a, ["children", "sx", "mt", "mb", "p"]);
    return (React.createElement(Box, Object.assign({ sx: Object.assign({ overflowX: "auto", whiteSpace: "nowrap", display: "flex", gap: 0.4, borderRadius: 1, mt,
            p,
            mb, border: "1px solid #919EAB14", flexWrap: "nowrap", "& > *": {
                flexShrink: 0,
            }, "&::-webkit-scrollbar": { display: "none" }, msOverflowStyle: "none", scrollbarWidth: "none" }, sx) }, rest), children));
};
export default ScrollableTabContainer;
